function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useEffect } from "react";
import { UnstyledControlledSelect } from "./UnstyledControlledSelect";

/*
  Props:
    - onValidationChange: (function) Function that will be called every time the field changes between valid and invalid. (also runs on mount)
    - required: (boolean) When true, an empty string as the field value will be invalid.
    - options: (array) An array of options for the select.
    - name: (string) The name of the field.
    - placeholder: (string, optional) The placeholder text to display when no option is selected.
    - label: (string, optional) The label for the field.
    - value: (string) The current value of the select.  if there is no initial value the value needs to be null
    - onChange: (function) The function to call when the field value changes.
 */

const UnstyledControlledValidationSelect = ({
  onValidationChange = ({
    name,
    isValid
  }) => null,
  classPrepend = 'unstyled',
  required = false,
  options,
  name = "",
  placeholder,
  label = "",
  showToggleIcon = true,
  value,
  onChange,
  ...rest
}) => {
  const [isValidSelect, setIsValidSelect] = useState(false);
  const [invalidSelectMessage, setInvalidSelectMessage] = useState("");
  useEffect(() => {
    // if the select is preselected
    // then validate the option value
    if (value) {
      validateSelect({
        name,
        value
      });
    }
  }, []);
  useEffect(() => {
    onValidationChange({
      name,
      isValid: isValidSelect
    });
  }, [isValidSelect]);
  const validateSelect = ({
    name,
    value
  }) => {
    onChange({
      name,
      value
    });
    if (required === true && value === "") {
      setInvalidSelectMessage(`Required`);
      setIsValidSelect(false);
      return;
    }
    setInvalidSelectMessage("");
    setIsValidSelect(true);
  };
  return /*#__PURE__*/React.createElement(UnstyledControlledSelect, _extends({
    classPrepend: classPrepend,
    options: options,
    name: name,
    placeholder: placeholder,
    helperText: invalidSelectMessage,
    label: label,
    showToggleIcon: showToggleIcon,
    value: value,
    onChange: validateSelect
  }, rest));
};
export { UnstyledControlledValidationSelect };